import type { ChangelogEntry } from "../types";

/**
 * VIB-2832. «Nytt i Revehiet» deles i kuraterte utrullinger for alle og
 * systemrapport (denne loggen) for superadmin.
 */
export const UTRULLINGER_2026_10: ChangelogEntry = {
  id: "2026-10-07-utrullinger",
  date: "2026-10-07",
  title: "Nytt i Revehiet viser utrullinger i stedet for enkeltleveranser",
  summary:
    "Ansatte ser én samlet forklaring per modul når noe rulles ut. Denne detaljerte loggen er flyttet til fanen «Systemrapport».",
  sections: [
    {
      heading: "Hjelp",
      items: [
        {
          title: "Utrullinger per modul",
          kind: "nytt",
          body: "Hver utrulling har modul, ingress, temagrupper, «På vei» og «Rettinger», og tastatursnarveier vises som tastetegn. Den første forklarer hjelpesenteret og selve «Nytt i Revehiet».",
        },
        {
          title: "Boksen ved innlogging gjelder bare utrullinger",
          kind: "forbedret",
          body: "Enkeltleveranser gir ikke lenger boks ved innlogging. Den kommer når en ny utrulling er ute.",
        },
        {
          title: "Systemrapporten er bare for superadmin",
          kind: "forbedret",
          body: "Loggen med én oppføring per leveranse, med søk og typefilter, ligger under fanen «Systemrapport».",
          minRole: "superadmin",
        },
      ],
    },
  ],
};
